import { searchFilterRegexp, includeDiscontinuedFilterRegexp } from '../constants/search-filter-regexp';
export var deserializeSearchFilter = function (value) {
    return deserializeFilter(value, searchFilterRegexp);
};
export var deserializeIncludeDiscontinuedFilter = function (value) {
    return deserializeFilter(value, includeDiscontinuedFilterRegexp);
};
function deserializeFilter(value, filterRegexp) {
    var deserializedValue = null;
    var searchFilterMatch = (value || '').match(filterRegexp) || [];
    if (searchFilterMatch.length > 0) {
        var searches = searchFilterMatch[0].split(',');
        deserializedValue = { searchQuery: searches[1] };
    }
    searchFilterRegexp.lastIndex = 0;
    return deserializedValue;
}
